<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-card shadow="never">
                    <el-row :gutter="20">
                        <el-col class="text-md-left" :span="10">
                            <el-input
                                placeholder="รหัสลูกค้า, ชื่อลูกค้าหรืออีเมล"
                                v-model="searchText"
                                @input="onSearch()"
                                >
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </el-col>
                        <el-col :span="5" class="text-md-left">
                            <el-button type="primary" @click="onSearch()">ค้นหา</el-button>
                        </el-col>
                        <el-col :span="9" class="text-md-right btn-box">
                            <FilterDropdown
                                :dateSort="false"
                                :fixedstatus="true"
                                :filterDropdownCase.sync="filterDropdownCase"
                                :isOpenFilterDropdown="isOpenFilterDropdown"
                                :handleChangeVisibility="handleChangeVisibility"
                                ref="dropdownParent"
                            >
                                <template v-slot:closeFilter>
                                    <el-button @click="cancelFilter()" data-testid="btnCancel" style="width:100%">
                                        Cancel
                                    </el-button>
                                </template>
                                <template v-slot:searchFilter>
                                    <el-button type="primary" style="width:100%" @click="onSearch()">
                                        Submit
                                    </el-button>
                                </template>
                            </FilterDropdown>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 20px;">
                        <el-col class="text-md-left" :sm="24">
                            <el-table
                            v-loading="loadingTable"
                            :data="customerList"
                            ref="customerTable"
                            :default-sort = "{prop: 'createdAt', order: 'descending'}"
                            stripe
                            :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                            style="width: 100% !important;"
                            :row-key="getRowKey"
                            >
                                <el-table-column prop="customerCode" label="รหัสลูกค้า" width="100">
                                    <div slot-scope="scope">
                                        {{scope.row.userCode}}
                                    </div>
                                </el-table-column>
                                <el-table-column prop="customerName" label="ชื่อลูกค้า" width="200">
                                    <div slot-scope="scope">
                                        {{scope.row.firstName}} {{scope.row.lastName}}
                                    </div>
                                </el-table-column>
                                <el-table-column prop="customerEmail" label="อีเมล" width="250">
                                    <div slot-scope="scope">
                                        {{scope.row.email}}
                                    </div>
                                </el-table-column>
                                <el-table-column prop="customerSubscriptionStatus" label="สถานะการชำระเงิน" width="150">
                                    <div slot-scope="scope">
                                        <el-row v-if="getSubscriptionPaymentStatusLabel(scope.row.subscriptionStatus) === 'ยังไม่จ่ายเงิน'" type="flex" align="center">
                                            <div style="margin-right: 5px;">
                                                <span class="text-red font-bullet">•</span>
                                            </div>
                                            <div>
                                                <span class="text-red"> ยังไม่ได้ชำระเงิน</span>
                                            </div>
                                        </el-row>
                                        <el-row v-else type="flex" align="center">
                                            <div style="margin-right: 5px;">
                                                <span class="text-green font-bullet">•</span>
                                            </div>
                                            <div>
                                                <span class="text-green"> ชำระเงินแล้ว</span>
                                            </div>
                                        </el-row>
                                    </div>
                                </el-table-column>
                                <el-table-column prop="customerSubscriptionStatus" label="สถานะแพ็กเกจ" width="120">
                                    <div slot-scope="scope">
                                        {{getSubscriptionStatusLabel(scope.row.subscriptionStatus)}}
                                    </div>
                                </el-table-column>
                                <el-table-column prop="customerSubscriptionType" label="แพ็กเกจปัจจุบัน" width="300">
                                    <div slot-scope="scope">
                                        <div v-if="scope.row.packageCode">{{convertEnumPackageCode(scope.row.packageCode)}} Package แบบ{{scope.row.subscriptionType ? convertEnumSubscription(scope.row.subscriptionType) : ''}}</div>
                                        <div v-else>-</div>
                                    </div>
                                </el-table-column>
                                <el-table-column prop="" label="สถานะการยืนยันตัวตน" width="200">
                                    <div slot-scope="scope">
                                        {{getApproveStatusLabel(scope.row.approveStatus, scope.row.isApprove) }}
                                    </div>
                                </el-table-column>
                                <el-table-column fixed="right" label="จัดการ" width="75" type="flex" justify="center">
                                    <template slot-scope="scope">
                                        <el-button :key="scope.$index" size="small" icon="el-icon-user" type="primary" plain @click="showCustomerDetail(scope.row)"></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                        <el-col style="margin-top:10px;">
                            <el-pagination
                                @size-change="changeLimitPage"
                                @current-change="changeCurrentPage"
                                :current-page.sync="pagination.currentPage"
                                :page-sizes="pagination.pageSizes"
                                :page-size="10"
                                layout="prev, pager, next, sizes"
                                :total="pagination.allPage * pagination.limit">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>

        <modal-all-customer-base
            :detail.sync="customerDetail"
            @closeModalCustomer="closeDialog"
            @onClickCreateQrDialog="isShowCreateQrDialog = $event"
            @onClickPaymentDetailDialog="isShowPaymentDetailDialog = $event"
        ></modal-all-customer-base>

        <create-qr-payment
            :detail.sync="isShowCreateQrDialog"
            @closeModalQrPayment="closeDialog"
            @fetchHistoryList="customerDetail.fetchHistoryList = $event"
        ></create-qr-payment>

        <payment-detail
            :detail.sync="isShowPaymentDetailDialog"
            @closeModalQrPayment="closeDialog"
        ></payment-detail>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import FilterDropdown from '@/components/FilterDropdown/FilterDropdownAllCustomer'
import ModalAllCustomerBase from '@/components/Customer/AllCustomer/ModalAllCustomerBase'
import CreateQrPayment from '@/components/Customer/AllCustomer/CreateQrPayment'
import PaymentDetail from '@/components/Customer/AllCustomer/PaymentDetail'
import { SUBSCRIPTION_TYPE_TH as enumSubscriptionTypeTh, packageCode as enumPackageCode } from '@/constant/subscription.js'
export default {
    name: 'allCustomerTable',
    components: {
        FilterDropdown,
        ModalAllCustomerBase,
        CreateQrPayment,
        PaymentDetail
    },
    data () {
        return {
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            searchText: '',
            customerList: [],
            customerDetail: {
                dialog: false,
                userId: null,
                fetchHistoryList: false,
                userCode: null
            },
            timeoutSearch: null,
            isOpenFilterDropdown: false,
            filterDropdownCase: {
                user_status: [],
                subscription_status: [],
                approve_status: []
            },
            filterDropdownShowCase: {
                package_code: null,
                subscription_type: null,
                account_status: null,
                expire_within: false
            },
            isShowCreateQrDialog: {
                dialog: false,
                isCreate: null,
                userId: null
            },
            isShowPaymentDetailDialog: {
                dialog: false,
                isCreate: null,
                detail: null,
                userId: null,
                userCode: null
            },
            loadingTable: false
        }
    },
    created () {
        this.filterDropdownCase.user_status = [-1]
        this.filterDropdownCase.subscription_status = [-1]
        this.filterDropdownCase.approve_status = [-1]
        this.fetchListCustomer()
    },
    methods: {
        convertEnumPackageCode (code) {
            return enumPackageCode[code]
        },
        convertEnumSubscription (code) {
            return enumSubscriptionTypeTh[code]
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchListCustomer()
        },
        changeCurrentPage () {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.fetchListCustomer()
        },
        handleChangeVisibility (value) {
            this.isOpenFilterDropdown = value
        },
        cancelFilter () {
            this.isOpenFilterDropdown = false
            this.$nextTick(() => {
                this.$refs.dropdownParent.$refs.dropdown.hide()
            })
            this.filterDropdownCase = this.filterDropdownShowCase
        },
        closeFilter () {
            this.isOpenFilterDropdown = false
            this.$nextTick(() => {
                this.$refs.dropdownParent.$refs.dropdown.hide()
            })
        },
        onSearch () {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            if (this.filterDropdownCase.user_status.length > 0) {
                let userStatus = []
                this.filterDropdownCase.user_status.forEach(e => {
                    if (e === -1) {
                        userStatus.push(-1)
                    } else if (e === 'Leadpool' || e === 1) {
                        userStatus.push(1)
                    } else if (e === 'Customer' || e === 2) {
                        userStatus.push(2)
                    }
                })
                this.filterDropdownCase.user_status = userStatus
            } else {
                this.filterDropdownCase.user_status = [-1]
            }
            if (this.filterDropdownCase.subscription_status.length > 0) {
                let subscriptionStatus = []
                this.filterDropdownCase.subscription_status.forEach(e => {
                    if (e === -1) {
                        subscriptionStatus.push(-1)
                    } else if (e === 'New' || e === 1) {
                        subscriptionStatus.push(1)
                    } else if (e === 'Active' || e === 2) {
                        subscriptionStatus.push(2)
                    } else if (e === 'Expired' || e === 4) {
                        subscriptionStatus.push(4)
                    }
                })
                this.filterDropdownCase.subscription_status = subscriptionStatus
            } else {
                this.filterDropdownCase.subscription_status = [-1]
            }
            if (this.filterDropdownCase.approve_status.length > 0) {
                let approveStatus = []
                this.filterDropdownCase.approve_status.forEach(e => {
                    if (e === -1) {
                        approveStatus.push(-1)
                    } else if (e === 'ยังไม่ได้ยืนยันตัวตน' || e === 0) {
                        for (let i = 0; i < 6; i++) {
                            approveStatus.push(i)
                        }
                    } else if (e === 'รอตรวจสอบ' || e === 6) {
                        approveStatus.push(6)
                        approveStatus.push(9)
                    } else if (e === 'ต้องการข้อมูลเพิ่มเติม' || e === 7) {
                        approveStatus.push(7)
                    } else if (e === 'ยืนยันตัวตนสำเร็จ' || e === 8) {
                        approveStatus.push(8)
                    }
                })
                this.filterDropdownCase.approve_status = approveStatus
            } else {
                this.filterDropdownCase.approve_status = [-1]
            }
            this.fetchListCustomer()
            this.closeFilter()
            this.$refs.customerTable.clearSelection()
        },
        showCustomerDetail (data) {
            this.customerDetail.dialog = !this.customerDetail.dialog
            this.customerDetail.userId = data.userId
            this.customerDetail.userCode = data.userCode
            this.isShowCreateQrDialog.userId = data.userId
            this.isShowPaymentDetailDialog.userId = data.userId
        },
        closeDialog () {
            this.customerDetail.dialog = !this.customerDetail.dialog
        },
        fetchListCustomer () {
            clearTimeout(this.timeoutSearch)
            this.timeoutSearch = setTimeout(async () => {
                this.loadingTable = true
                let param = {
                    search: this.searchText,
                    limit: this.pagination.limit,
                    offset: this.pagination.offset,
                    user_status: this.filterDropdownCase.user_status,
                    subscription_status: this.filterDropdownCase.subscription_status,
                    approve_status: this.filterDropdownCase.approve_status
                }
                let res = await fgApi.user.searchAllCustomer(param)
                if (res.success) {
                    if (this.searchText === param.search) {
                        this.customerList = res.data ? res.data : []
                        this.pagination.allPage = res.allPage
                    }
                }
                this.loadingTable = false
            }, 1000)
        },
        getRowKey (row) {
            return row.userId
        }
    }
}
</script>

<style lang="scss" scoped>
.font-bullet {
    font-size: 40px;
}
</style>
<style lang="scss">
.el-table__header-wrapper .el-table__header {
    width: 100% !important;
}
.el-table__body-wrapper .el-table__body {
    width: 100% !important;
}
</style>
